// eslint-disable-next-line
import React, { useState, useEffect, useWindowFocus} from "react";
// eslint-disable-next-line

import NavBar from "./Navbar";

import "./Messages.css";
import { use } from "react";
import {
  Link,
  Route,
  Routes,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import * as flatted from "flatted";

import { getFunctions, httpsCallable } from 'firebase/functions';

import { ConsoleView, isMobile } from "react-device-detect";

// const socket = io.connect('http://localhost:3000');
import axios from "axios";

import Students from "./Mapofstudents/Mapofstudents";

// eslint-disable-next-line


import { auth, firebase, firebaseConfig } from "../Firebase/config";
// eslint-disable-next-line
import {
  onSnapshot,
  orderBy,
  limit,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  FieldValue,
  getCountFromServer,
} from "@firebase/firestore";

import { initializeApp } from 'firebase/app';

import {
  admin,
  getAuth,
  signInWithEmailAndPassword,
  initializeAuth, getReactNativePersistence,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  onAuthStateChanged,
  deleteUser,
  connectAuthEmulator,
  setPersistence,
} from "@firebase/auth";


import ReactNativeAsyncStorage from '@react-native-async-storage/async-storage';


// Removed firebase-functions as it is not compatible with React Native


const app = initializeApp(firebaseConfig);

// const auth2 = initializeAuth(app, {
//   persistence: setPersistence(ReactNativeAsyncStorage)
// });







// eslint-disable-next-line


const MAX = 10;

function Getclasses({ route, navigation }) {
  // eslint-disable-line no-unused-vars

  const { only2studentid, studentid, classid, language, role } = useParams();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [donotshow, setDonotshow] = useState();
  const [someoneisloggedin, setSomeoneisloggedin] = useState(false);
  const [id2, setId2] = useState();
  const [school2, setSchool2] = useState();
  const [town2, setTown2] = useState();
  const [state2, setState2] = useState();
  const [schoolid2, setSchoolid2] = useState();

  const [role2, setRole2] = useState();
  const [school, setSchool] = useState();
  const [todayspasses, setTodayspasses] = useState();

  const [lasttwomonths, setLasttwomonths] = useState([]);
  const [lasttwomonths2, setLasttwomonths2] = useState();

  const [selectedclass, setSelectedclass] = useState();

  const [updatesent, setUpdatesent] = useState();

  const [activename, setActivename] = useState("Active Passes");

  const [lastupdate, setLastupdate] = useState(0);
  const [selectedpass, setSelectedpass] = useState();
  const [idselected, setIdselected] = useState();
  const [currentstudentid, setCurrentsstudentid] = useState();
  const [arrayofstudentpasses, setArrayofstudentpassees] = useState();

  const [firstname, setFirstname] = useState();
  const [lastname, setLastname] = useState();
  const [studentname, setStudentname] = useState("");
  const [numberofdaysago, setNumberofdaysago] = useState();

  const [newdatestring, setNewdatestring] = useState();
  const [path, setPath] = useState();

  const [currentUrl, setCurrentUrl] = useState(window.location.href);

  const [popupData, setPopupData] = useState(null);

  const auth = getAuth();

  const location = useLocation();

  const [newWindow, setNewWindow] = useState(null);

  const [urlValue, setUrlValue] = useState("");
  const [data, setData] = useState(null);

  const [stringToSend, setStringToSend] = useState("");

  const [response, setResponse] = useState("");

  const [courses2, setCourses2] = useState();
  const [courses23, setCourses23] = useState();
  const [data3, setData3] = useState(null);

  const [email, setEmail] = useState('');

  const [courses3, setCourses3] = useState([]);
  const [idToken, setIdToken] = useState(null);
  const [isSignedIn, setIsSignedIn] = useState(false);



  const callFirebaseFunction = async () => {

    

    try {
      const response = await axios.post('https://us-central1-portfolio-c4a93.cloudfunctions.net/simpleFunction', {}, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      alert(`Response: ${response.data}`);
        try {
            // Add your code here
        } catch (error) {
          
      console.error(error);
      alert('Error calling the function');
        }




    // try {
    //   const functions = getFunctions();
    //   const simpleFunction = httpsCallable(functions, 'simpleFunction');
    //   const result = await simpleFunction();
    //   console.log('Function response:', result.data);
    // } catch (error) {
    //   console.error('Error calling Firebase function:', error);
    // }
  } catch (error) {
    console.error("Error occurred:", error);
  };

}

  const getclasses4 = async (e) => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      getclasses4a(e);
    } else {
      getclasses4b(e);
    }
  };

  const [receivedData, setReceivedData] = useState(null);

  useEffect(() => {
    const handleReceiveMessage = (event) => {
      if (event.origin === "http://localhost:3002") {
        // Replace with the origin of your child window
        setReceivedData(event.data);
        console.log(event.data);
      }
    };

    window.addEventListener("message", handleReceiveMessage);

    return () => {
      window.removeEventListener("message", handleReceiveMessage);
    };
  }, []);

  const openChildWindow = () => {
    const childWindow = window.open("http://localhost:3002/login", "_blank"); // Replace with the URL of your child window
  };

  const getclasses4a = async (e) => {
    try {
      const response = await fetch("http://localhost:3002/getAccessToken2");
      const data = await response.json();
      const accessToken = data;
      console.log(accessToken);

      console.log("YOO");
    } catch (error) {
      console.error("Error fetching access token:", error);
    }
  };

  const getclasses4b = async (e) => {
    // try {
    //   const response = await fetch(
    //     "https://sleepy-falls-78216-6abb1d3b0d95.herokuapp.com/getAccessToken2"
    //   );
    //   const data = await response.json();
    //   const accessToken = data.accessToken;
    //   console.log(accessToken);
    // } catch (error) {
    //   console.error("Error fetching access token:", error);
    // }
  };

  // const getclasses3 = async (e) => {
  //   if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  //     getclasses3a(e);
  //   } else {
  //     getclasses3b(e);
  //   }
  // };
  const [authUrl, setAuthUrl] = useState(null);
  const [code, setCode] = useState(null);
  useEffect(() => {
    // Check if the Google Sign-In script is already loaded
    if (!document.getElementById('google-signin-script')) {
      const script = document.createElement('script');
      script.id = 'google-signin-script'; // Add an ID to prevent duplicate loading
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
  
      script.onload = () => {
        // Initialize Google Sign-In after the script is loaded
        window.google.accounts.id.initialize({
          client_id: '315295652774-uqgfp53af3jtgelehjvf2695593patht.apps.googleusercontent.com',
          callback: handleCredentialResponse,
          ux_mode: 'redirect',
          login_uri: 'https://us-central1-portfolio-c4a93.cloudfunctions.net/oauthCallback', // Replace with your backend URL
        });
  
        const buttonDiv = document.getElementById('buttonDiv');
        if (buttonDiv) {
          window.google.accounts.id.renderButton(
            buttonDiv,
            { theme: 'outline', size: 'large' }
          );
        }
  
        // Ensure prompt is called only once
        window.google.accounts.id.prompt();
      };
  
      return () => {
        // Clean up the script when the component unmounts
        const existingScript = document.getElementById('google-signin-script');
        if (existingScript) {
          document.body.removeChild(existingScript);
        }
      };
    } else {
      // If the script is already loaded, just call prompt
      window.google.accounts.id.prompt();
    }
  }, []);



  const fetchCourses = async () => {
    console.log("inside fetchCourses function");
    try {
      const response = await fetch('https://classroom.googleapis.com/v1/courses', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${idToken}`, // Use the JWT token
          'Content-Type': 'application/json',
        },
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const data = await response.json();
      console.log('Fetched courses:', data);
      setCourses3(data.courses || []);
    } catch (error) {
      console.error('Error fetching courses:', error);
    }
  };

    const handleCredentialResponse = (response) => {
      console.log("inside handleCredentialResponse function");
      try {
        // Log the encoded JWT token
        console.log('Encoded JWT ID token: ' + response.credential);
    
        // Save the token for further use
        setIdToken(response.credential);
    
        // Fetch courses or perform other actions using the token
        fetchCourses(); // Ensure fetchCourses is implemented correctly
        setIsSignedIn(true); // Update the state to reflect the user is signed in
      } catch (error) {
        console.error('Error handling credential response:', error);
      }
    };

  useEffect(() => {
    if (typeof idToken != "undefined") {
  getclasses();
    }
  }, [idToken]);


  const fetchCourses2 = async (e) => {
    try {
      // First, get the access token
      const tokenResponse = await axios.get(
        "http://localhost:3002/oauthcallback?code=4%2F0AanRRruINCsin1Gg04mOMGK5phYt_Y__nQXfi4EsIEUszdkrnkPGOkhK6IafrzNOzNtYlg&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fclassroom.courses.readonly"
      );
      // const accessToken = tokenResponse.data.accessToken;

      setCourses2(tokenResponse.data.courses);

      // Then, use the access token to get the courses from Google API
      // const coursesResponse = await axios.get("https://www.googleapis.com/classroom/v1/courses", {
      //   headers: {
      //     Authorization: `Bearer ${accessToken}`,
      //   },
      // });

      console.log(tokenResponse); // Log the courses data
      // return coursesResponse.data;
    } catch (error) {
      console.log("Error fetching courses from API:", error);
    }
  };

  const getclasses3a = async (e) => {
    try {
      // First, get the access token
      // const tokenResponse = await axios.get("http://localhost:3002/login");
      // const accessToken = tokenResponse.data.accessToken;
      // setAuthUrl(tokenResponse.data.authUrl);
      // Then, use the access token to get the courses from Google API
      // const coursesResponse = await axios.get("https://www.googleapis.com/classroom/v1/courses", {
      //   headers: {
      //     Authorization: `Bearer ${accessToken}`,
      //   },
      // });
      // console.log(tokenResponse.data.courses); // Log the courses data
      // return coursesResponse.data;
    } catch (error) {
      console.log("Error fetching courses from API:", error);
    }
  };
  // useEffect(() => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const authCode = urlParams.get("code");
  //   if (authCode) {
  //     console.log(authCode);
  //     setCode(authCode);
  //   } else {
  //     getclasses3a();
  //   }
  // }, []);

  useEffect(() => {
    if (code) {
      console.log(code, "this is the cdee");
    }
  }, [code]);

  // const getclasses3b = async (e) => {
  //   try {
  //     // First, get the access token
  //     const tokenResponse = await axios.get(
  //       "http://localhost:3002/getAccessToken"
  //     );
  //     const accessToken = tokenResponse.data.accessToken;

  //     // Then, use the access token to get the courses from Google API
  //     const coursesResponse = await axios.get(
  //       "https://www.googleapis.com/classroom/v1/courses",
  //       {
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //         },
  //       }
  //     );

  //     console.log(coursesResponse.data); // Log the courses data
  //     return coursesResponse.data;
  //   } catch (error) {
  //     console.log("Error fetching courses from API:", error);
  //   }
  // };


  const getclasses = async () => {

      try {
        const response = await axios.post(
          'https://us-central1-portfolio-c4a93.cloudfunctions.net/simpleFunction',
          {},
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        if (response.status === 200) {
          alert(`Response: ${response.data}`);
        } else {
          console.error('Unexpected response:', response);
          alert('Unexpected response from the server');
        }
      } catch (error) {
        if (error.response) {
          console.error('Server responded with an error:', error.response.data);
          alert(`Error: ${error.response.data}`);
        } else if (error.code === 'ECONNABORTED') {
          console.error('Request timed out:', error.message);
          alert('Request timed out. Please try again later.');
        } else if (error.request) {
          console.error('No response received:', error.request);
          alert('No response received from the server. Please check your network connection.');
        } else {
          console.error('Error setting up the request:', error.message);
          alert('Error setting up the request');
        }
      }

  }


  const getclassesA = async () => {
    try {
      // Retrieve the Firebase ID token
      const token = await auth.currentUser.getIdToken();
      console.log("Retrieved ID Token:", token);
  
      // Example API call using the token
      const response = await axios.post(
        'https://classroom.googleapis.com/v1/courses',
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );
  
      if (response.status === 200) {
        alert(`Response: ${JSON.stringify(response.data)}`);
      } else {
        console.error('Unexpected response:', response);
        alert('Unexpected response from the server');
      }
    } catch (error) {
      if (error.response) {
        console.error('Server responded with an error:', error.response.data);
        alert(`Error: ${error.response.data}`);
      } else if (error.request) {
        console.error('No response received:', error.request);
        alert('No response received from the server. Please check your network connection.');
      } else {
        console.error('Error setting up the request:', error.message);
        alert('Error setting up the request');
      }
    }
  };

const getclassesB = async () => {
try {
  const response = await axios.get("http://localhost:3002/initiateLogin");
  const authUrl = response.data.authUrl;

  if (authUrl) {
    const newWindow = window.open(authUrl, "_blank");
    const handleMessage = (event) => {
      if (event.origin === "http://localhost:3002") {
        const { courses } = event.data;
        setCourses3(courses || []);
        newWindow.close();
        window.removeEventListener("message", handleMessage);
      }
    };
    window.addEventListener("message", handleMessage);
  } else {
    console.error("Failed to retrieve auth URL");
  }
} catch (error) {
  console.error("Error initiating login:", error);
}

}

  const getclassesC= async () => {
    try {
      await signInWithEmailAndPassword(auth, "mkrebs@rpsk12.org", "matt1974");
       console.log('Success', 'User signed in successfully!');
    } catch (error) {
      alert('Error '+ error.message);
    }
  };

  const fetchData = async () => {
    // try {
    //   const response = await fetch("http://localhost:3002/get-data");
    //   const data = await response.json();
    //   const accessToken = data;
    //   setCourses2(data.courses);
    //   console.log(accessToken);

    //   console.log("YOO");
    // } catch (error) {
    //   console.error("Error fetching access token:", error);
    // }
  };


  useEffect(() => {
      if (typeof courses2 !== "undefined") {
        const convertZuluTimestampToDatetime = (timestamp) => {
          const date = new Date(timestamp);
          const date2 = date.getTime();
          console.log(date2, "this is the date");
          return date2;
        };
  
        let sortedCourses = courses2.sort((a, b) => convertZuluTimestampToDatetime(b.creationTime) - convertZuluTimestampToDatetime(a.creationTime));
  
        setCourses23(sortedCourses);
      }
    }, [courses2]);
  // filtere courses2
  const getclasses2 = async () => {
    // try {
    //   const response = await axios.get(
    //     "https://sleepy-falls-78216-6abb1d3b0d95.herokuapp.com/login"
    //   );
    //   console.log(response.data.courses);
    // } catch (error) {
    //   console.log("Error fetching courses from apis data");
    // }
  };


  
  const handleSubmitafterbuild = async (e) => {
      if (stringToSend !== "") {
        try {
          const res = await axios.post("", {
            data: stringToSend,
          });
          alert(res.data);
        } catch (error) {
          console.error("Error sending data:", error);
          alert("Error sending data. Ensure the server and client have compatible Cross-Origin-Opener-Policy and Cross-Origin-Embedder-Policy headers.");
        }
      }
    };

  // const handleSubmittest = async (e) => {
  //   if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  //     handleSubmittest2(e);
  //   } else {
  //     handleSubmittest3(e);
  //   }
  // };

  // const handleSubmittest3 = async () => {
  //   try {
  //     const response = await axios.get(
  //       "https://sleepy-falls-78216-6abb1d3b0d95.herokuapp.com/api/hello"
  //     );
  //     alert(response.data.message);
  //   } catch (error) {
  //     console.error("Error fetching health status:", error);
  //   }
  // };

  // const handleSubmittest2 = async () => {
  //   try {
  //     const response = await axios.get("http://localhost:3001/api/hello");
  //     alert(response.data.message);
  //   } catch (error) {
  //     console.error("Error fetching health status:", error);
  //   }
  // };

  // const handleSubmit2 = async (e) => {
  //   if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  //     handleSubmit3(e);
  //   } else {
  //     handleSubmit4(e);
  //   }
  // };

  // const handleSubmit3 = async (e) => {
  //   e.preventDefault();
  //   if (stringToSend !== "") {
  //     try {
  //       const res = await axios.post("http://localhost:3001/api/endpoint", {
  //         data: stringToSend,
  //       });
  //       alert("YO error sendinig data 2");
  //     } catch (error) {
  //       alert("YO error sendinig data 1");
  //     }
  //   }
  // };

  const handleSubmit4 = async (e) => {
    e.preventDefault();
    if (stringToSend !== "") {
      try {
        const res = await axios.post(
          "https://portfolio-c4a93.web.app/api/endpoint",
          {
            data: stringToSend,
          }
        );
        alert("YO error sendinig data 2");
      } catch (error) {
        alert("YO error sendinig data 1");
      }
    }
  };

  const handleSubmitWASWORKING = async (e) => {
    if (stringToSend != "") {
      e.preventDefault();

      try {
        const res = await axios.post("http://localhost:3001/api/endpoint", {
          data: stringToSend,
        });
      } catch (error) {
        console.error("Error sending data:", error);
      }
    }
    const handleDownload = async () => {
      if (typeof urlValue != "undefined" && urlValue != "") {
        const data = await axios.get(
          `http://localhost:3001/download?url=${urlValue}`
        );
        setData(data);
        setUrlValue("");
      }
    };
  };

  const openWindow = () => {
    fetch("http://localhost:3001/login", {
      mode: "no-cors", // This is the default, so you can omit it if you want
    }) // Replace with your actual API endpoint
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        return response.text();
        // Extract the string from the response body
      })
      .then((data) => {
        // Handle the received string

        // https://accounts.google.com/o/oauth2/v2/auth?access_type=offline&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fclassroom.courses.readonly&response_type=code&client_id=5397215201-4qc422ck0e6q7e9278fquss3gs4bt9pf.apps.googleusercontent.com&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Foauthcallback

        setNewWindow(data);
        alert(data + "what soes this loook like"); // Do something with the string on the frontend
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    if (newWindow) {
      console.log("this is the new window", newWindow);

      // 'https://classroom.googleapis.com/v1/courses?key=[YOUR_API_KEY]' \
      // --header 'Authorization: Bearer [YOUR_ACCESS_TOKEN]' \
      // --header 'Accept: application/json' \

      fetch(newWindow, {
        mode: "no-cors",
      });

      // fetch("https://www.googleapis.com/auth/classroom.courses.readonly&service=lso&flowName=GeneralOAuthLite&continue=https://accounts.google.com/signin/oauth/legacy/consent?authuser=unknown&part=AJi8hANXt3pRSN51t7xwIhdnoF1nytamVTM15sA2jyiZ25262P8kQGsh36S5YsTU-h25hQHt-GwvXch6Ks-Z2IomD3orz2s9kvPmIcctThkJjyCUED0HvAqeGoqrygEVcV3Cbj3Isvu9aYgJau5bq4LMbhLBRb9Jl2LacQ2J1nbhs_p291KGy3-v42VZ88UiEkyXIjbGk5AYK4bzCxaBFIfi2zf0tdPU_tWSwrkvATzswhY5Y7P1pz0-DWL01ZwYrvEB6rbfREF5BgSnWqFBcWMo0MQkgfUu3vREYGHhvqxHam6GqXDmBYegcQEzjbBtvE35vPQmTGcBdzpmS683_m0t7luRWR6KWdlT5Phy_CAKzJsoaVToCxntAVSzLVKyvVGMj-MTMP3ATO-_nv6p2q8Vv2WSxWNhCox4ukS7dPCVEsRod-QYHE4&flowName=GeneralOAuthFlow&as=S-953644693:1732454791661769&client_id=407408718192.apps.googleusercontent.com", {mode: "no-cors"})
    }
  }, [newWindow]);

  console.log(JSON.stringify(location));

  async function signout() {
    auth.signOut();
    setId2();
  }

  const onChanged1 = (text) => {
    setStudentname(text);
  };

  const onChanged2 = (text) => {
    setNumberofdaysago(text);
  };

  useEffect(() => {
    if (typeof numberofdaysago != "undefined") {
      let today = Date.now();
      let newdate = new Date(today - numberofdaysago * (1000 * 3600 * 24))
        .toString()
        .substr(4, 11);

      setNewdatestring(newdate);
    }
  }, [numberofdaysago]);

  // useEffect(() => {
  //   console.log(typeof location.state, "You see this issn't there");
  //   if (location.state == null) {

  //     let aaa = JSON.parse(localStorage.getItem("school"));
  //     setSchool2(aaa);
  //     let bbb = JSON.parse(localStorage.getItem("town"));
  //     setTown2(bbb);
  //     let ccc = JSON.parse(localStorage.getItem("state"));
  //     setState2(ccc);
  //     let ddd = JSON.parse(localStorage.getItem("schoolid"));
  //     setSchoolid2(ddd);
  //     setNumberofdaysago(1);

  //   }
  //   else if (typeof location.state.id != "undefined") {

  //     setId2(location.state.id);
  //     setSchool2(location.state.school);
  //     setTown2(location.state.town);
  //     setState2(location.state.state);
  //     setSchoolid2(location.state.schoolid);
  //     setNumberofdaysago(1);
  //   } else {
  //     navigate("/SignIn");
  //   }
  // }, []);

  useEffect(() => {
    if (
      typeof id2 != "undefined" &&
      typeof state2 != "undefined" &&
      typeof town2 != "undefined" &&
      typeof school2 != "undefined"
    ) {
      console.log("1234");
      // getclasses();
    }
  }, [id2, state2, town2, school2]);

  let now = Date.now();
  let twohours = 1000 * 60 * 60 * 2;

  let twohoursago = now - twohours;

  let sixtydays = 1000 * 60 * 60 * 24 * 60;
  let sixtydaysago = now - sixtydays;

  // async function getclasses() {
  //   const q = query(
  //     collection(firebase, "passes"),
  //     where("school", "==", school2),
  //     where("town", "==", town2),
  //     where("state", "==", state2),
  //     where("timepassinitiated", ">", sixtydaysago),
  //     orderBy("timepassinitiated", "desc")
  //   );

  //   let allpasses = [];

  //   const querySnapshot = await getDocs(q).then(function (snapshot) {
  //     snapshot.forEach((doc) => {
  //       allpasses.push(doc.data());
  //     });

  //     localStorage.setItem("allpasses", JSON.stringify(allpasses));

  //     console.log(allpasses, "Is it finiding all passes.");

  //     const onpassnow = allpasses.filter((person) => {
  //       return person.leftclass > twohoursago && person.returned == 0;
  //     });

  //     console.log(onpassnow, "this is whatwasin on pass now.");

  //     localStorage.setItem("onpass", JSON.stringify(onpassnow));

  //     setTimeout(() => {
  //       let butter = Date.now();
  //       setUpdatesent(butter);
  //     }, 500);
  //   });
  // }

  if (typeof schoolid2 != "undefined") {
    onSnapshot(doc(firebase, "schools", schoolid2), (doc) => {
      console.log("BBBBBBBB");
      if (doc.data().update != lastupdate) {
        setLastupdate(doc.data().update);
      } else {
        console.log("Don't do anything");
      }
    });
  }
  const [courses, setCourses] = useState([]);

  const handleLogin = async () => {
    // try {
    //     const response = await fetch('http://localhost:3000/login', {mode:'cors'});
    //     const data = await response.json();
    //     console.log({ data })
    //   }
    //   catch (e) {
    //     console.log(e)
    //   }

    try {
      const response = await fetch("/login", { mode: "no-cors" });
      const data = await response.json();
      const yo = JSON.stringify(data);
      const yo2 = JSON.parse(data);

      console.log(yo, yo2, "YOOOOOOO");
    } catch (e) {
      console.log(e);
    }
  };

  const handleLogin2 = async () => {
    // return fetch('http://localhost:3000/login')
    //   .then(response => response.json())
    //   .then(json => {
    //     console.log(json.movies)
    //   })
    //   .catch(error => {
    //     console.error(error);
    //   });

    // try {
    //   const response = await fetch('http://localhost:3000/login', {mode:'cors'});
    //   const data = await response.json();
    //   console.log({ data })
    // }
    // catch (e) {
    //   console.log(e)
    // }

    const newWindow = window.open("http://localhost:3001/login", "_blank");

    // window.location.href = "http://localhost:3000/login";

    // Update state whenever the URL changes

    if (newWindow) {
      // Set an item in localStorage
      //  localStorage.setItem("data", flatted.stringify(newWindow));

      console.log(flatted.stringify(newWindow), "yoooooo");
    } else {
      // Handle the case where the window could not be opened
      console.error("Failed to open window.");
    }

    setTimeout(() => {
      let abe = JSON.parse(localStorage.getItem("data"));

      console.log(abe);
    }, 2000);

    //  try {
    //       const response = await fetch('http://localhost:3000/login', {mode:'cors'});

    //       const data = await response.json();
    //         console.log({ data }, "YOo")

    //         setPath({data});
    //        }
    //     catch (e) {
    //       console.log(e)
    //       }

    // const response = await fetch('http://localhost:3000/login' , {
    //   method: 'GET'
    // })

    // const data = await response.json();
    // console.log(data);

    // const headers = [
    //   "Access-Control-Allow-Origin", "http://localhost:3000/login"
    // ]

    // axios.get('/api/data')
    // .then(response => {
    //   console.log(response.data); // 'Hello from the server!'
    // })
    // .catch(error => {
    //   console.error(error);
    // });

    // const obj = {
    //   method: 'POST',
    //   body: JSON.stringify("Hello") ,
    //   mode: "no cors" ,
    //   headers: {
    //       'Access-Control-Allow-Origin': '*' ,
    //       'Content-type': 'application/json'
    //   }
    // }

    // const myHeaders = {"headers": ["Access-Control-Allow-Origin", "*"]};

    // let headers = {headers: ['Access-Control-Allow-Origin', 'http://localhost:3000/login']};

    // return fetch("http://localhost:3000/login", {"headers": ["Access-Control-Allow-Origin","http://localhost:3000/login"]})

    // const instance = axios.create(
    //   {
    //           baseURL: "http://localhost:3000/login",
    //     })
    //     instance();

    //     const instance = axios.create({
    //       baseURL: "http://localhost:3000/login",
    //       mode: "no-cors"
    //     });

    // instance();

    // const fetchPromise = fetch("http://localhost:3000/login", {
    //   method: "GET",
    //   mode: "cors",
    //   headers: {
    //     "Content-Type": "text/xml",
    //   }
    //   // ,
    //   // body: "<person><name>Arun</name></person>",
    // });

    // fetchPromise.then((response) => {
    //   console.log(response.status);
    // });

    // axios({
    //   method: 'GET',
    //   headers: { "Content-Type":"application/x-www-form-urlencoded; charset=UTF-8; application/json","Access-Control-Allow-Headers":"*", "Access-Control-Allow-Origin":"http://localhost:3000/login"},
    //   url: 'http://localhost:3000/login',
    //   data: "yooooo"
    // }).then(function (response) {
    //   console.log(response.data);
    // });

    // axios.get("http://localhost:3000/login").then((json) => {

    //       alert(json);

    //     })

    // try {
    //   const response = await axios.get("http://localhost:3000/login");
    //   setCourses(response.data.courses || []);
    // } catch (error) {
    //   console.log("Error fetching courses from apis data");
    // }

    // return fetch("http://localhost:3000/login", obj)
    // .then((response) => console.log(response, "hi"))
    // .then((json) => {

    //     setPath(json);
    //     alert(json);

    //   })
    //   .catch((error) => {
    //     console.error(error);
    //   });

    //   fetch('http://localhost:3000/login', {
    //  "mode": 'no-cors'

    //     // "Access-Control-Allow-Origin": "http://localhost:3000/login"
    //   })
    //   .then(json => {
    //       console.log(json.stringify(json))
    //     })
    //     .catch(error => {
    //       console.error(error);
    //     });
    // try {
    //   const response = await axios.get("http://localhost:3000/courses", {
    //     "Referrer-Policy": "strict-origin-when-cross-origin",
    //   });
    //   setCourses(response.data.courses || []);
    // } catch (error) {
    //   console.log("Error fetching courses from apis data");
    // }
  };

  // let why = window.location.href;

  //   const handleUrlChange = () => {
  //     setCurrentUrl(why);
  //   };

  //   useEffect(() => {
  //     handleUrlChange()
  //   }, []);

  const [url, setUrl] = useState(window.location.href);

  useEffect(() => {
    // Update state when URL changes
    const handleUrlChange = () => {
      setUrl(window.location.href);
    };

    window.addEventListener("popstate", handleUrlChange);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("popstate", handleUrlChange);
    };
  }, []);

  useEffect(() => {
    if (typeof currentUrl != "undefined") {
      console.log(currentUrl, "yo");
    }
  }, [currentUrl]);

  const fetchCourses3 = async () => {
    try {
      const response = await axios.get("http://localhost:3001/courses", {
        "Referrer-Policy": "strict-origin-when-cross-origin",
      });
      setCourses3(response.data.courses || []);
    } catch (error) {
      console.log("Error fetching courses from apis data");
    }
  };

  useEffect(() => {
    if (typeof selectedpass != "undefined") {
      let idselect = selectedpass.id;
      let student = selectedpass.studentid;
      let fname = selectedpass.firstname;
      let lname = selectedpass.lastname;
      setIdselected(idselect);
      setCurrentsstudentid(student);
      setFirstname(fname);
      setLastname(lname);
    }
  }, [selectedpass]);

  // useEffect(() => {
  //   let headers = new Headers();

  //   headers.append("Content-Type", "application/json");
  //   headers.append("Accept", "application/json");
  //   headers.append("Access-Control-Allow-Origin", "*");
  //   headers.append("Access-Control-Allow-Methods", "*");
  //   headers.append("Access-Control-Allow-Headers", "*");

  // headers.append('Origin','http://localhost:3000');
  // Make a request for a user with a given ID

  // axios
  //   .get("http://localhost:3000/courses" )
  //   .then(function (response) {
  //     // handle success
  //     console.log('response to login route', response.data);
  //   })
  //   .catch(function (error) {
  //     // handle error
  //     console.log('error to login route',error);
  //   });
  // }, []);

  // useEffect(() => {
  //   if (typeof lastupdate != "undefined" && lastupdate > 0) {
  //     getclasses();
  //   }
  // }, [lastupdate]);

  // useEffect(
  //   () =>
  //     onSnapshot(doc(firebase, "schools", schoolid2), (doc) => {
  //       if (doc.data().update > 0) {
  //         getclasses();
  //       } else {
  //         console.log("Don't do anything");
  //       }
  //     }),
  //   []
  // );

  async function gogetmp4() {
    navigate("/MakeMP4");
  }

  const navigate = useNavigate();

  const sections = [
    { Name: "Active Passes", key: 1 },
    { Name: "Search By Name", key: 2 },
    { Name: "Search By Date", key: 3 },
  ];

  async function signout() {
    auth.signOut();
    setId2();

    navigate("/");
  }

  useEffect(() => {
    setDonotshow(true);
  }, []);

  useEffect(() => {
    if (typeof path != "undefined") {
      goagain();
    }
  }, [path]);

  const [openWindows, setOpenWindows] = useState();

  const goagain = () => {
    const newWindow = window.open(path.data.authUrl, "_blank");

    setOpenWindows(newWindow);

    newWindow.addEventListener("message", (event) => {
      console.log(event.origin, path.data.authUrl, "hi");
      if (event.origin === path.data.authUrl) {
        const data = event.data;
        console.log("Data from popup:", JSON.stringify(data));
      }
    });
  };

  useEffect(() => {
    if (typeof openWindows != "undefined") {
      console.log(openWindows);
    }
  }, [openWindows]);

  useEffect(() => {
    if (typeof selectedclass != "undefined") {
      setActivename(selectedclass.Name);
    }
  }, [selectedclass]);

  const [value, setValue] = useState(0);

  // const isFocused = useWindowFocus();

  // useEffect(() => {
  //   if (isFocused == true) {
  //    fetchData();
  //   }
  // }, [isFocused]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        console.log("Tab is active");
        fetchData();
        // Perform actions when the tab becomes active
      } else {
        console.log("Tab is inactive");
        // Perform actions when the tab becomes inactive
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Clean up the event listener on unmount
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  const getBackgroundSize = () => {
    return { backgroundSize: `${(value * 100) / MAX}% 100%` };
  };



  const API_BASE_URL = "https://api-hkshnm7duq-uc.a.run.app";

  const login = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/login`, { // Include cookies if necessary
      });
  
      // Log the authUrl received from the backend
      console.log("Auth URL:", response.data.authUrl);
  
      // Redirect the user to the authUrl
      if (response.data.authUrl) {
        window.location.href = response.data.authUrl;
      } else {
        console.error("Auth URL not received from the server.");
        alert("Failed to retrieve the authentication URL.");
      }
    } catch (error) {
      console.error("Error during login:", error.response?.data || error.message);
      alert("Failed to initiate login. Please check the console for details.");
    }
  };
// Function to call the /get-data2 endpoint

const Getyourgcclasses = async () => {
  try {
    const response = await axios.get(`https://api-hkshnm7duq-uc.a.run.app/get-data2`, {// Include cookies if necessary
    });
    console.log("Data retrieved:", response.data);
    alert("Data retrieved successfully. Check the console for details.");
  } catch (error) {
    console.error("Error fetching data:", error);
    alert("Failed to fetch data.");
  }
};



  return (
    <div className="App22">
      <NavBar
        donotshow={donotshow}
        role={role}
        sections={sections}
        setSelectedclass={setSelectedclass}
        activename={activename}
      />
      <div className="App">
        {/* //frontend Youtube Downolader */}

        {/* end */}

        <header className="App-header">
          <div id="buttonDiv"></div>
            <div className="innertext">Make MP4 From Link</div>
     

          <br></br>
          <div className="field229" onClick={() => getclasses()}>
            <div className="innertext">Simple Function</div>
          </div>

          <br></br>

          <div className="field229" onClick={() => getclassesA()}>
            <div className="innertext">Get Classes</div>
          </div>

          <br></br>


          <div className="field229" onClick={() => getclassesB()}>
            <div className="innertext">Get Classes2</div>
          </div>

          <br></br>

          <div className="field229">
            <div className="innertext">Trying To Login Again</div>
          </div>

          <br></br>

          <div className="field229" onClick={() => Getyourgcclasses()}>
            <div className="innertext">Trying To Getyourgcclasses</div>
          </div>

          <br></br>

          <div className="field229" onClick={() => getclassesC()}>
            <div className="innertext">Delete User</div>
          </div>

          <br></br>

          <div className="field229">
            <div onClick={() => fetchData()}>
              Get Code First then {data3} see if anythign shwos up.
            </div>
          </div>

          {typeof courses23 != "undefined" &&
            courses23.map((course) => (
              <div key={course.id}>
                {course.name} {course.id}
              </div>
            ))}

          <br></br>

          <div className="field229" onClick={() => getclasses4()}>
            <div className="innertext">Fetch Code First</div>
          </div>

          <br></br>

          {isMobile ? (
            <div className="field229" onClick={() => gogetmp4()}>
              <div className="innertext">Save File To App</div>
            </div>
          ) : (
            <div className="field229" onClick={() => gogetmp4()}>
              <div className="innertext">Get Saved File From App</div>
            </div>
          )}

          <br></br>
          <div></div>
        </header>
      </div>
    </div>
  );
}

export default Getclasses;
